class WarrantyPricingItemModel {
  constructor(values = {}) {
    this.price = values?.price || 0
    this.provider_name = values?.provider_name || ''
    this.plan_name = values?.plan_name || ''
  }
}

export default WarrantyPricingItemModel
